import React from 'react';
import { batteryToText } from 'utils/utils';
import statusConverter from 'utils/statusConverter';

export const columnSetter = (moduleScn, flag) => {
  const columns = [
    {
      Header: '장치정보',
      columns: [
        {
          Header: 'No',
          accessor: 'rnum',
        },
        {
          Header: '장치명',
          accessor: 'modelNm',
        },
        {
          Header: '위치번호',
          accessor: 'areaNo',
        },
        {
          Header: '위치명',
          accessor: 'areaNm',
        },
      ],
    },
    {
      Header: '측정결과',
      columns: [
        {
          Header: (
            <span>
              WIND(m/s)
            </span>
          ),
          accessor: 'wind',
        },
      ],
    },
    {
      Header: '상태정보',
      columns: [
        {
          Header: 'seqnum',
          accessor: 'seqnum',
        },
        {
          id: 'status',
          Header: () => <div>상태</div>,
          Cell: ({ row }) => statusConverter(row.original.status, row.original.relayFlag),
        },
        {
          Header: 'rssi',
          accessor: 'rssi',
        },
        {
          Header: '측정시간',
          accessor: 'regTime',
        },
      ],
    },
  ];

  return columns;
};
